import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/** @jsx jsx */
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { Box, xcss } from '@atlaskit/primitives';
import { components } from '@atlaskit/select';
import { css, jsx } from '@emotion/react';
import { AddOptionAvatar } from './AddOptionAvatar';
import { SizeableAvatar } from './SizeableAvatar';
import { messages } from './i18n';
import { getAvatarUrl, isEmail, isGroup } from './utils';
import PeopleIcon from '@atlaskit/icon/glyph/people';
export const scrollToValue = (valueContainer, control) => {
  const {
    top,
    height
  } = valueContainer.getBoundingClientRect();
  const {
    height: controlHeight
  } = control.getBoundingClientRect();
  if (top - height < 0) {
    valueContainer.scrollIntoView();
  }
  if (top + height > controlHeight) {
    valueContainer.scrollIntoView(false);
  }
};
const groupTagContainer = xcss({
  paddingLeft: 'space.025'
});
const nameWrapper = css({
  paddingLeft: `${"var(--ds-space-050, 4px)"}`
});
export class MultiValue extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "getElemBefore", () => {
      const {
        data: {
          data
        },
        selectProps
      } = this.props;
      if (isEmail(data)) {
        return selectProps.emailLabel ? jsx(AddOptionAvatar, {
          isLozenge: true,
          label: selectProps.emailLabel
        }) : jsx(FormattedMessage, messages.addEmail, label => jsx(AddOptionAvatar, {
          isLozenge: true,
          label: label
        }));
      }
      if (isGroup(data)) {
        return jsx(Box, {
          xcss: groupTagContainer
        }, jsx(PeopleIcon, {
          label: "group-icon",
          size: "small"
        }));
      }
      return jsx(SizeableAvatar, {
        appearance: "multi",
        src: getAvatarUrl(data)
      });
    });
    this.containerRef = /*#__PURE__*/React.createRef();
  }
  componentDidUpdate() {
    const {
      isFocused
    } = this.props;
    if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) {
      scrollToValue(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
  }
  shouldComponentUpdate(nextProps) {
    const {
      data: {
        label,
        data
      },
      innerProps,
      isFocused
    } = this.props;
    const {
      data: {
        label: nextLabel,
        data: nextData
      },
      innerProps: nextInnerProps,
      isFocused: nextIsFocused
    } = nextProps;

    // We can ignore onRemove here because it is an anonymous function
    // that will be recreated every time but with the same implementation.
    return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
  }
  render() {
    const {
      children,
      innerProps,
      ...rest
    } = this.props;
    return jsx(components.MultiValue, _extends({}, rest, {
      innerProps: {
        ref: this.containerRef
      },
      cropWithEllipsis: false
    }), this.getElemBefore(), " ", jsx("div", {
      css: nameWrapper
    }, children));
  }
}